<template lang="jade">
  div.Tiles
    component(v-for="tile in fdata.tiles"
              is="tile"
              ":fdata"="tile")
</template>

<script>
import tile from 'src/components/inputs/buttons/_sub/tile'

export default {
  data () {
    return {
      uid: this.$parent.uid
    }
  },
  props: {
    fdata: {
      type: Object,
      coerce: x => {
        return { tiles: x.content[0].content }
      },
      required: true
    }
  },
  components: {
    tile
  }
}
</script>



// WEBPACK FOOTER //
// tiles.vue?aae200be